// eslint-disable-next-line
import CryptoJS from 'crypto-js';


// Fonction pour chiffrer un objet JSON
export function encrypt(jsonData) {
  if(!jsonData)
    return '';
  const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(jsonData), process.env.REACT_APP_CRYPTO_KEY).toString();
  return (ciphertext);
};

// Fonction pour déchiffrer un objet JSON
export function decrypt(ciphertext) {
  if(!ciphertext)
    return '';
  const bytes = CryptoJS.AES.decrypt(ciphertext, process.env.REACT_APP_CRYPTO_KEY);
  const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return (decryptedData);
};